import React, { useEffect, useState, useRef } from "react";
import {
  bp_add_meta_data,
  bp_get_machine_by_machine_typ,
  bp_get_testing_type,
  bp_machine_data,
  bp_save_batch_product_inventory,
  bp_save_sample_details,
} from "../../../utils/api";
import { toast } from "react-toastify";
import { Input, Select, Button, Descriptions, Table } from "antd";
import MainCard from '@/components/MainCard';
import { batch, useDispatch, useSelector } from "react-redux";
import { settab_number } from '@/store/reducers/tabNumber';
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';

function AddSample() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const operation_data = state?.operation_data;
  const dispatch = useDispatch();
  const [machine, set_machine] = useState("");
  const [testing_type, set_testing_type] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    submit_function();
  };

  const submit_function = async () => {
    try {
      await bp_save_sample_details(
        {
          sample_number: operation_data?.operation_id,
          batch_id: operation_data?.batch_id,
          quantity: quantity,
          machine_id: machine,
          testing_type_id: testing_type,
        },
        success_bp_save_batch_product_inventory
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_bp_save_batch_product_inventory = (res) => {
    console.log(res);
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      navigate("/batch");
      toast.success("Metadata added Successfully");
    }
  };

  const [added_data, set_added_data] = useState([{}]);
  const [sample_number, set_sample_number] = useState("");
  const [quantity, set_quantity] = useState("");

  useEffect(() => {
    console.log("added_data", added_data);
  }, [added_data]);

  const machineDetailColumns = [
    {
      title: <span className="text-lg font-bold">Mass</span>,
      align: "center",
      key: "Mass",
      dataIndex: "mass",
      width: "25%",
      render: (_, __, index) => (
        <span className="text-2xl">{operation_data?.instruction}</span>
      ),
    },
    {
      title: <span className="text-lg font-bold">Testing Type</span>,
      align: "center",
      key: "Testing_type",
      dataIndex: "testing_type",
      width: "25%",
      render: (_, __, index) => (
        <Select
          size="large"
          placeholder="Select Testing Type"
          value={testing_type}
          onChange={(value) => set_testing_type(value)}
          style={{
            width: "100%",
            fontSize: "24px",
          }}
          options={testing_type_list?.map((item) => ({
            label: item.testing_type,
            value: item.testing_type_id,
          }))}
        />
      ),
    },
    {
      title: <span className="text-lg font-bold">Sample Number</span>,
      align: "center",
      key: "Sample_nO",
      dataIndex: "sample_number",
      width: "25%",
      render: (_, __, index) => (
        <Input
          type="text"
          size="large"
          value={sample_number}
          onChange={(e) => set_sample_number(e.target.value)}
          style={{
            fontSize: "24px",
          }}
        />
      ),
    },
    {
      title: <span className="text-lg font-bold">Quantity</span>,
      align: "center",
      key: "Quantity",
      dataIndex: "quantity",
      width: "25%",
      render: (_, __, index) => (
        <Input
          type="number"
          size="large"
          value={quantity}
          onChange={(e) => set_quantity(e.target.value)}
          style={{
            fontSize: "24px",
          }}
        />
      ),
    },
  ];

  //####################### Handle Api's######################################################

  const [machine_data, setMachineData] = useState([]);
  const [testing_type_list, set_testing_type_list] = useState([]);
  const get_all_machine = async () => {
    try {
      await bp_get_machine_by_machine_typ(success_machine_list_get, {
        machine_type_id: operation_data?.machine_id,
      });
      await bp_get_testing_type(success_bp_get_testing_type);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_machine_list_get = (res) => {
    setMachineData(res?.data?.data);
  };

  const success_bp_get_testing_type = (res) => {
    set_testing_type_list(res?.data?.data);
  };

  useEffect(() => {
    get_all_machine();
  }, [operation_data]);

  const resetFunction = () => {
    set_machine("");
  };

  return (
    <MainCard darkTitle title="Sampling" backbutton>
      <div className="space-y-4">
        <Descriptions
          title=""
          bordered
          column={2}
          contentStyle={{
            fontSize: "24px",
          }}
          labelStyle={{
            fontSize: "32px",
            fontWeight: "bold",
          }}
          items={[
            {
              key: "5",
              label: "Instruction",
              children: operation_data?.instruction,
              span: 2,
            },
            {
              key: "1",
              label: "Batch No",
              children: operation_data?.batch_number,
            },
            {
              key: "2",
              label: "Operation",
              children: `${operation_data?.operation_type} - ${operation_data?.operation_number}`,
            },
            {
              key: "3",
              label: "Machine",
              children: (
                <Select
                  value={machine}
                  size="large"
                  placeholder="Select Machine"
                  onChange={(value) => set_machine(value)}
                  style={{
                    width: "100%",
                    fontSize: "24px",
                  }}
                  options={machine_data?.map((item) => ({
                    label: item.machine_name,
                    value: item.machine_id,
                  }))}
                />
              ),
            },
            {
              key: "4",
              label: "Duration",
              children: operation_data?.max_duration,
            },
          ]}
        />

        <Table
          dataSource={added_data}
          columns={machineDetailColumns}
          size="small"
          bordered
          pagination={false}
        />

        <div className="flex justify-end items-end gap-2">
          <Button
            type="primary"
            size="large"
            style={{
              backgroundColor: defaultColors.primary,
              borderColor: defaultColors.primary,
              height: "50px",
              fontSize: "24px",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </MainCard>
  );
}

export default AddSample;
